import { FadeUp } from "./Motion";
import { GoldGlobe } from "./GoldGlobe";

export const Positioning = () => {
  return (
    <section className="relative py-32 md:py-52 bg-navy text-paper overflow-hidden border-t border-b border-ink/10">
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(250,250,250,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(250,250,250,0.6) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      {/* 3D wireframe globe backdrop */}
      <GoldGlobe className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[135vw] h-[135vw] md:w-[820px] md:h-[820px] opacity-70 pointer-events-none" />

      {/* Radial vignette to keep the statement legible over the globe */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side at 50% 50%, rgba(18,58,51,0.85) 0%, rgba(18,58,51,0.35) 45%, rgba(18,58,51,0) 75%)",
        }}
      />

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 text-center">
        <FadeUp>
          <div className="font-mono-cap text-teal/90 mb-10">Positioning Statement</div>
        </FadeUp>
        <FadeUp delay={0.1}>
          <p className="font-display text-4xl md:text-7xl leading-[1.02] max-w-5xl mx-auto text-paper">
            &ldquo;Traditional finance measures <br className="hidden md:block" />
            <span className="italic text-paper/70">financial history</span>.
            <br />
            We measure <span className="italic text-teal">business potential</span>.&rdquo;
          </p>
        </FadeUp>
        <FadeUp delay={0.2}>
          <div className="font-display italic text-2xl md:text-3xl text-paper/90 mt-14">
            Making invisible businesses <span className="text-teal">visible</span>.
          </div>
          <div className="font-mono-cap text-paper/50 mt-6">— Credablr</div>
        </FadeUp>
      </div>
    </section>
  );
};
